var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CopyWrapper',[_c('h2',[_vm._v(_vm._s(_vm.SectionNumber)+". "+_vm._s(_vm.Data.title))]),_c('StyledMarkup',{domProps:{"innerHTML":_vm._s(_vm.Data.copy)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }